import React, {useEffect} from "react";

interface UseIntersectionObserverOptions {
  onIntersect: () => void; // ref가 화면에 보일 때 실행할 함수
  root?: HTMLElement | null;
  rootMargin?: string;
  threshold?: number;
  enabled?: boolean; // 일시적으로 관찰을 끄고 싶을 때
}

export default function useIntersectionObserver(
  ref: React.RefObject<HTMLElement | null>,
  {
    onIntersect,
    root = null,
    rootMargin = "0px",
    threshold = 0.5,
    enabled = true,
  }: UseIntersectionObserverOptions,
) {
  useEffect(() => {
    if (!enabled) return;
    const target = ref.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            onIntersect();
          }
        });
      },
      {root, rootMargin, threshold},
    );

    observer.observe(target);

    return () => {
      observer.disconnect();
    };
  }, [ref, onIntersect, root, rootMargin, threshold, enabled]);
}
